import { AuthModalBottomDescription } from "./AuthModalBottomDescription/styles";
import { AuthModalButton } from "./AuthModalButton";
import AuthModalHeaderLogo from "./AuthModalHeaderLogo";
import AuthModalHeaderTitle from "./AuthModalHeaderTitle";
import { AuthModalInput } from "./AuthModalInput";

export const AuthModalForm = {
  Button: AuthModalButton,
  Title: AuthModalHeaderTitle,
  Logo: AuthModalHeaderLogo,
  Input: AuthModalInput,
  BottomDescription: AuthModalBottomDescription,
};
